import React from "react";
import { AboutUsUI } from "components";

const AboutUs = () => {
  return (
    <>
      <AboutUsUI />
    </>
  );
};

export { AboutUs };
